// API configuration
export const API_URL = process.env.REACT_APP_API_URL || '/api';
const DEFAULT_DEV_BACKEND_ORIGIN = 'http://localhost:3001';

export const getApiBaseUrl = () => {
  if (API_URL.startsWith('http')) {
    return API_URL;
  }

  if (process.env.NODE_ENV === 'development') {
    return `${DEFAULT_DEV_BACKEND_ORIGIN}${API_URL.startsWith('/') ? API_URL : `/${API_URL}`}`;
  }

  return API_URL;
};

// Dev mode detection
export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development';
};

// Dev mode user configuration
export const DEV_USER = {
  id: 1,
  username: 'devuser',
  email: 'dawid@lasz.uk',
  full_name: 'Dev User'
};

// Mock JWT token for dev mode (this bypasses backend auth)
export const DEV_TOKEN = 'dev-mode-token';

// Get the base URL for the backend (without /api suffix)
export const getBackendBaseUrl = () => {
  const resolvedApiUrl = getApiBaseUrl();
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const normalizedApi =
    resolvedApiUrl.startsWith('http') || origin === ''
      ? resolvedApiUrl
      : `${origin}${resolvedApiUrl.startsWith('/') ? resolvedApiUrl : `/${resolvedApiUrl}`}`;

  return normalizedApi.replace(/\/api\/?$/, '');
};

// Helper to get full URL for uploaded files
export const getUploadUrl = (path) => {
  if (!path) return null;
  const baseUrl = getBackendBaseUrl();
  return `${baseUrl}${path}`;
};
